<template>
    <!-- <tr class="border-b-[1px] border-[#FFF] border-opacity-10">
        <td class="px-3 w-[15%] truncate py-2 text-start text-sm">
            <div class="flex flex-col align-middle">
                <div class="truncate text-[#FFF] font-bold">{{ group.name }}</div>
                <div class="truncate text-[10px] text-gray-400">{{ group.year_range }}</div>
            </div>
        </td>

        <td class="px-3 w-[20%] pb-[5px] pt-[7px] text-start flex items-center text-sm">
            <div>
                <Skeletor v-if="photoTrainer == null && trainer" class="rounded-full z-0" width="28" height="28" pill as="div" :shimmer="true"/>
                <div v-else class="w-10 h-10 rounded-full overflow-hidden flex items-end bg-[#BD9135] bg-opacity-20 border-[#BD9135] border-[1px]">
                    <img v-if="trainer?.photo" :src="photoTrainer">
                    <div v-else class="w-full h-full  text-[#BD9135] flex justify-center items-center">
                        {{ trainer?.name[0] + trainer?.surname[0] }}
                    </div>
                </div>
            </div>
            <div class="ml-[30px] text-[#FFF]">
                <span v-if="trainerName != 'Не задано'" class="truncate">{{ trainerName }}</span>
                <span v-else-if="trainer == null" class="truncate">Не заданий</span>
                
                <Skeletor v-else class="rounded-[10px]" width="70" height="15" pill as="div" :shimmer="true"/>
            </div>    
        </td>
        <td class="w-[15%] text-[#FFF] text-end relative">
            <div v-if="studentsCount != undefined" class="absolute left-[0] top-[50%] translate-y-[-50%] text-end w-[60px]">{{ studentsCount }}</div>
            <Skeletor v-else class="rounded-[10px]" width="40" height="15" pill as="div" :shimmer="true"/>
        </td>
        <td class="px-3 py-2 text-end text-sm w-[50%]">
            <button @click="$emit('openGroupCard')" class="px-2 py-1 rounded-[10px] text-sm font-medium">
                <img src="@/assets/icons/pen_icon.svg" class="w-6 h-6">
            </button>
            <button v-if="currentAdminRole != 'supervisor'" @click="deleteGroup" class="px-2 py-1 rounded-[10px] text-sm font-medium text-red-600">
                <img src="@/assets/icons/trash_icon.svg" class="w-6 h-6 ">
            </button>
        </td>
    </tr> -->

    <TableRow>
        <TableCell :asChild="true">
            <div class="player-groups__group-cell">
            <div class="group-cell__name">{{ group.name }}</div>
            <div class="group-cell__years">{{ group.year_range }}</div>
            </div>
        </TableCell>
        <TableCell :asChild="true">
            <div class="player-groups__couch-cell">
            <AvatarContainer
                :src="photoTrainer"
                :extraSmall="true"
            />
            <p>{{ trainerName }}</p>
            </div>
        </TableCell>
        <TableCell :value="studentsCount" />
        <TableCell :asChild="true" :text-end="true">
            <div class="player-groups__actions-cell">
                <button>
                    <img src="@/assets/icons/pen_icon.svg" class="w-[25px]" alt="edit" @click="$emit('openGroupCard')" />
                </button>
                <button>
                    <img src="@/assets/icons/trash_icon.svg" class="w-[25px]" alt="delete" @click="deleteGroup" />
                </button>
            </div>
        </TableCell>
    </TableRow>
</template>

<script>
    import { getTrainerById, getStudentsCountByGroupId, deleteGroupRequest } from '@/services/apiRequests'
    import { ref, onBeforeMount, watch, computed } from 'vue'
    import { Skeletor } from 'vue-skeletor'

    export default {
        name: 'group-card',

        props: {
            group: {
                type: Object,
                required: true
            }
        },

        setup(props, { emit }) {
            const trainer = ref(null)

            watch(() => props.group.trainer_id, () => {
                console.log('updated id')
                getTrainerById(props.group.trainer_id).then(res => {
                    trainer.value = res.data
                })
            })

            const photoTrainer = computed(
                () => trainer.value === null ? null : process.env.VUE_APP_API_URL + 'static/' + trainer.value.photo
            )
            const trainerName = computed(
                () => trainer.value === null ? 'Не задано' : trainer.value.surname + ' ' + trainer.value.name[0] + '.'
            )

            const studentsCount = ref(undefined)

            const deleteGroup = () => {
                emit('deleteGroup', props.group)
            }

            onBeforeMount(async () => {
                studentsCount.value = 0

                // setInterval(async () => {
                //     const countRes = await getStudentsCountByGroupId(props.group.group_id)
                //     studentsCount.value = countRes.data > 0 ? countRes.data : 0
                // }, 1000)

                const countRes = await getStudentsCountByGroupId(props.group.group_id)
                studentsCount.value = countRes.data > 0 ? countRes.data : 0
                console.log('countRes.data', countRes.data)

                if (props.group.trainer_id === null) return

                const res = await getTrainerById(props.group.trainer_id)
                trainer.value = res.data 
            })

            const currentAdminRole = ref(localStorage.getItem('userType'))

            return {
                photoTrainer, 
                trainerName,
                studentsCount,
                trainer,
                deleteGroup,
                currentAdminRole
            }
        },

        components: {
            Skeletor
        }
    }
</script>

<style lang="scss" scoped>

    .vue-skeletor {
        background-color: #ccc;
        animation: shimmer 1.5s infinite;
        animation-duration: 2s; 
        animation-timing-function: ease-in-out;
    }

    /* Default keyframes used in skeletor */
    @keyframes shimmer {
        0% {
            opacity: .5;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: .5;
        }
    }

</style>